import moment from "moment";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { todayStartDate,todayEndDate } from "modules/utilities/utility";
function SupportFeedback() {
  // const todayStartDate = moment()
  //   .startOf("day")
  //   .format("ddd+MMM+D+YYYY+18%3A30%3A00+GMT%2B0530");

  // const todayEndDate = moment()
  //   .endOf("day")
  //   .format("ddd+MMM+D+YYYY+18%3A29%3A99+GMT%2B0530");

  const pageNumber = 1;

  const navigate = useNavigate();

  useEffect(() => {
    navigate(
      `/customer-feedback?tab=customer&pageNumber=${pageNumber}&sd=${todayStartDate}&ed=${todayEndDate}`
    );
  }, [navigate, pageNumber, todayStartDate, todayEndDate]);

  return;
}

export default SupportFeedback;
